import { render } from "./NotificationPanel.vue?vue&type=template&id=fb619140&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"

import "./NotificationPanel.vue?vue&type=style&index=0&id=fb619140&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb619140"]])

export default __exports__